export class ReservationTypesWS {
  id: number;
  name: string;
}
